import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { images } from '../../components/shared/assets';
import { useBlogXML } from '../../hooks/useBlogXML';
import { usePropertyBlogFiltering } from '../../hooks/useBlogFiltering';
import { BlogPost } from '../../utils/browserXMLParser';
import './BlogAtacama.css';

const BlogAtacama: React.FC = () => {
  const { posts: allXMLPosts, loading } = useBlogXML();
  
  // Filter posts specifically for Atacama
  const { filteredPosts: atacamaPosts } = usePropertyBlogFiltering(allXMLPosts, 'atacama');
  
  // Initialize all interactive features
  useEffect(() => {
    const cleanup = initializeAllFeatures();
    return cleanup;
  }, []);

  const formatDate = (date: Date) => {
    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
  };

  return (
    <div className="blog-atacama-page">
      {/* Navigation */}
      <SmartNavigation 
        defaultVariant="transparent"
        scrolledVariant="light"
        autoSwitchOnScroll={true}
      />

      {/* Hero Section */}
      <div className="blog-atacama-hero">
        <div className="blog-atacama-hero-content">
          <h1>Atacama Stories</h1>
          <p>
            Discover the stories, culture, and adventures from the world's driest desert. 
            From ancient astronomy to modern art, explore the rich narratives that emerge from this extraordinary landscape.
          </p>
        </div>
        <div 
          className="blog-atacama-hero-image" 
          style={{ backgroundImage: `url(${images.galleryDesertLandscape})` }} 
        />
      </div>

      {/* Blog Posts Section */}
      <section className="blog-atacama-posts">
        <div className="blog-atacama-posts-header">
          <h2>Latest from Atacama</h2>
          <p>{atacamaPosts.length} articles</p>
        </div>

        <div className="blog-atacama-posts-grid">
          {atacamaPosts.slice(0, 8).map((post: BlogPost) => (
            <article key={post.id} className="blog-atacama-post-card">
              <div className="blog-atacama-post-image">
                <img 
                  src={post.featuredImage || images.galleryDesertLandscape} 
                  alt={post.title} 
                />
              </div>
              <div className="blog-atacama-post-content">
                <h3>{post.title}</h3>
                <div className="blog-atacama-post-meta">
                  <span>{post.author}</span>
                  <span>-</span>
                  <span>{formatDate(post.publishDate)}</span>
                </div>
                <p>{post.excerpt || post.content.substring(0, 150) + '...'}</p>
                <Link to={`/blog/${post.slug}`} className="blog-atacama-post-link">
                  READ MORE
                </Link>
              </div>
            </article>
          ))}
        </div>

        {atacamaPosts.length > 8 && (
          <div className="blog-atacama-see-more">
            <Link to="/blog?destination=atacama" className="blog-atacama-see-more-btn">
              See All Atacama Stories ({atacamaPosts.length})
            </Link>
          </div>
        )}
      </section>

      {/* Instagram Section */}
      <InstagramSection 
        title="Follow us on Instagram @awasiexperience"
        posts={[
          { src: images.instagram1, alt: "Instagram post 1" },
          { src: images.instagram2, alt: "Instagram post 2" },
          { src: images.instagram3, alt: "Instagram post 3" },
          { src: images.instagram4, alt: "Instagram post 4" }
        ]}
      />

      {/* Footer */}
      <Footer variant="atacama" />
    </div>
  );
};

export default BlogAtacama;